import * as types from '../types';

const INITIAL_STATE = {
  id: null,
  url: null,
  method: null,
  data: null,

  result: {
    type: null,
    data: null,

    initialized: false,
  },
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.INIT_PAYMENT: {
      return INITIAL_STATE;
    }
    case types.INVOICE_CREATED: {
      const { id, url, method, data } = action.payload;

      return {
        ...state,
        id,
        url,
        method,
        data,
      };
    }
    case types.INIT_INVOICE_RESULT: {
      const { result_type, invoice } = action.payload;

      return {
        ...state,

        result: {
          type: result_type,
          data: invoice,

          initialized: true,
        },
      };
    }
    case types.SET_INVOICE_STATUS: {
      return {
        ...state,
        result: {
          ...state.result,
          data: {
            ...state.result.data,
            status: action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
}
